import React, { useState } from 'react';
import { Mail, Phone, MapPin, ArrowRight } from 'lucide-react';
import { api } from '../lib/api';

const Contatti = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', interest: '', message: '' });
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.createLead({ source: 'contatti', ...form });
      setSent(true);
      setTimeout(() => setSent(false), 4000);
      setForm({ name: '', email: '', phone: '', interest: '', message: '' });
    } catch {
      alert('Errore. Riprova.');
    }
  };

  return (
    <div className="bg-[#2b2b2b]">
      <section className="pt-32 pb-16 md:pt-40 md:pb-20 bg-[#141414]">
        <div className="max-w-[1000px] mx-auto px-6 lg:px-10 text-center">
          <div className="inline-block px-5 py-2.5 rounded-full border border-[#e9dfc0]/40 text-[#e9dfc0] text-[13px] mb-6">Contattaci</div>
          <h1 className="font-serif text-white text-5xl md:text-7xl leading-[1.05] mb-6">Parliamone</h1>
          <p className="text-[#e9dfc0]/80 max-w-2xl mx-auto">Compila il form: rispondiamo entro 24 ore lavorative.</p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10 grid md:grid-cols-3 gap-12">
          <div className="space-y-8">
            <div className="flex gap-4 items-start">
              <div className="w-11 h-11 rounded-full bg-[#e9dfc0]/15 text-[#e9dfc0] flex items-center justify-center"><Mail className="w-5 h-5" /></div>
              <div>
                <p className="text-white font-medium mb-1">Email</p>
                <p className="text-[#e9dfc0]/70 text-sm">info@etechpro.it</p>
              </div>
            </div>
            <div className="flex gap-4 items-start">
              <div className="w-11 h-11 rounded-full bg-[#e9dfc0]/15 text-[#e9dfc0] flex items-center justify-center"><Phone className="w-5 h-5" /></div>
              <div>
                <p className="text-white font-medium mb-1">Telefono</p>
                <p className="text-[#e9dfc0]/70 text-sm">Su appuntamento</p>
              </div>
            </div>
            <div className="flex gap-4 items-start">
              <div className="w-11 h-11 rounded-full bg-[#e9dfc0]/15 text-[#e9dfc0] flex items-center justify-center"><MapPin className="w-5 h-5" /></div>
              <div>
                <p className="text-white font-medium mb-1">Sede</p>
                <p className="text-[#e9dfc0]/70 text-sm">Italia</p>
              </div>
            </div>
          </div>

          <div className="md:col-span-2 bg-[#1e1e1e] border border-[#e9dfc0]/15 rounded-2xl p-8 md:p-10">
            <form onSubmit={submit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nome" className="w-full bg-[#2b2b2b] border border-[#4a4a4a] text-white placeholder:text-[#e9dfc0]/50 rounded-lg py-3.5 px-4 focus:outline-none focus:border-[#e9dfc0] transition-colors" />
                <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" className="w-full bg-[#2b2b2b] border border-[#4a4a4a] text-white placeholder:text-[#e9dfc0]/50 rounded-lg py-3.5 px-4 focus:outline-none focus:border-[#e9dfc0] transition-colors" />
              </div>
              <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Telefono" className="w-full bg-[#2b2b2b] border border-[#4a4a4a] text-white placeholder:text-[#e9dfc0]/50 rounded-lg py-3.5 px-4 focus:outline-none focus:border-[#e9dfc0] transition-colors" />
              <select required value={form.interest} onChange={(e) => setForm({ ...form, interest: e.target.value })} className="w-full bg-[#2b2b2b] border border-[#4a4a4a] text-white rounded-lg py-3.5 px-4 focus:outline-none focus:border-[#e9dfc0] transition-colors">
                <option value="" disabled>Sono interessato a…</option>
                <option>Servizi eCommerce standard</option>
                <option>ETech Temporary Management</option>
                <option>Ecommerce Etico</option>
                <option>E-gas</option>
                <option>Altro</option>
              </select>
              <textarea rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Raccontaci il tuo progetto" className="w-full bg-[#2b2b2b] border border-[#4a4a4a] text-white placeholder:text-[#e9dfc0]/50 rounded-lg py-3.5 px-4 focus:outline-none focus:border-[#e9dfc0] transition-colors resize-none" />
              <div className="flex items-center gap-4">
                <button type="submit" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-[#e9dfc0] text-[#2b2b2b] font-medium hover:bg-white transition-colors">
                  Invia <ArrowRight className="w-4 h-4" />
                </button>
                {sent && <p className="text-[#e9dfc0] text-sm">Messaggio inviato! Ti rispondiamo entro 24h.</p>}
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contatti;
